import React, { useEffect } from 'react'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4geodata_peruHigh from '@amcharts/amcharts4-geodata/peruHigh'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)

function Map({ data, showList }) {
  
  useEffect(() => {
    // Map instance
    let map = am4core.create('chartdiv', am4maps.MapChart)
    map.geodata = am4geodata_peruHigh
    map.chartContainer.wheelable = false
    map.seriesContainer.draggable = false
    map.seriesContainer.resizable = false
    map.maxZoomLevel = 1

    // Set projection
    map.projection = new am4maps.projections.Miller()

    // Map polygon series
    let polygonSeries = new am4maps.MapPolygonSeries()

    polygonSeries.useGeodata = true
    map.series.push(polygonSeries)
    polygonSeries.tooltip.background.fill = am4core.color("#f5f5f5");
    // Configure series
    let polygonTemplate = polygonSeries.mapPolygons.template
    polygonTemplate.tooltipText = '[bold]{name}[/] \n{value}% de municipios con 0% de ejecución \nTotal municipios: {total}'
    polygonSeries.tooltip.label.fontSize = 12


    polygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;

    // Create hover state and set alternative fill color
    //let hs = polygonTemplate.states.create('hover')
    //hs.properties.fill = am4core.color('#4c4c4c')

    // Add Zoom Control
    //map.zoomControl = new am4maps.ZoomControl()

    // Add heat rule
    /*polygonSeries.heatRules.push({
      property: 'fill',
      target: polygonSeries.mapPolygons.template,
      min: am4core.color('#5faa46'),
			max: am4core.color('#f44336'),
      minValue: 0,
      maxValue: 100
    })*/

    polygonSeries.mapPolygons.template.adapter.add("fill", function(fill, target) {
      if (target.dataItem) {
        if (target.dataItem.value >= 80) {
          return am4core.color("#f44336")
        }
        else if (target.dataItem.value >= 60) {
          return am4core.color("#ffb74d")
        }
        else if (target.dataItem.value >= 40) {
          return am4core.color("#ffee58")
        }
        else if (target.dataItem.value >= 20) {
          return am4core.color("#7cb342");
        }
        else if (target.dataItem.value >= 0) {
          return am4core.color("#5faa46");
        }
      }
      return fill;
    });

    polygonSeries.data = data

    polygonTemplate.events.on(
      'hit',
      (ev) => {
        const body = {
          id: ev.target.dataItem.dataContext.id,
          total: ev.target.dataItem.dataContext.total,
          value: ev.target.dataItem.dataContext.value
        }
        showList(body)
 
        polygonTemplate.propertyFields.fill = 'fill'
      },
      this
    )


    return function cleanup() {
      map.dispose()
    }

  }, [data])

  return <div id="chartdiv" style={{ width: '100%', height: '500px' }}></div>
}

export default Map
